import React from 'react'
import './Newsstyle.css'

const NewsList = ({title, description, url, urlToImage}) => {


  return (
    <div className='alldets'>
        <div className='newsapp'>
      <div className='newsitem'>
        <img className='newsimg img-fluid' src={urlToImage} alt={urlToImage} />
        <div className='article-content'>
        <h2 className='title text-white'>{title}</h2>
        <p className='description'>{description}</p>
        <button className='Bbtn'><a className='text-white' target='_blank' href={url}>Read more</a></button>
      </div>
      </div>
    </div>
    </div>
  )
}

export default NewsList